import useSelectModal from '~/hooks/useSelectModal';
import { useSelectModalStore } from '~/store';
import * as S from './SelectOptionsModal.styled';

export default function SelectOptionsModal() {
  const {
    click,
    isOpen,
    selectOptions,
    selectedOption,
    modalTitle: title,
  } = useSelectModalStore((state) => ({
    click: state.click,
    modalTitle: state.modalTitle,
    isOpen: state.isOpen,
    selectOptions: state.selectOptions,
    selectedOption: state.selectedOption,
  }));
  const { closeSelectModal } = useSelectModal();

  const handleChangeOptions = (option: string) => {
    if (click) {
      click(option);
    }
    closeSelectModal();
  };

  return (
    <>
      {isOpen && (
        <>
          <S.Container className='Modal'>
            <S.ContentWrapper>
              {title && (
                <S.TitleBox>
                  <S.Title>{title}</S.Title>
                </S.TitleBox>
              )}
              <S.Options>
                {selectOptions.map((option, idx) => (
                  <S.Option
                    key={`option${idx}_${option}`}
                    onClick={() => handleChangeOptions(option)}
                  >
                    <S.OptionList>
                      <S.Checked checked={selectedOption === option} />
                      <span>{option}</span>
                    </S.OptionList>
                  </S.Option>
                ))}
              </S.Options>
            </S.ContentWrapper>
          </S.Container>
          <S.Background
            onClick={() => closeSelectModal()}
            className='background'
          />
        </>
      )}
    </>
  );
}
